var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-prd-date-picker-field',{attrs:{"label":_vm.label,"rules":_vm.rules,"dense":"","is-birth-date":""},model:{value:(_vm.compValue),callback:function ($$v) {_vm.compValue=$$v},expression:"compValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }